import { Box, Button, Flex, IconButton, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import Select from "react-select";
import {
  homeworkUncommentReportRequest,
} from "../../../modules/admin-modules/reports/Actions";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { CSVLink } from "react-csv";
import { getAllHomeworksRequest } from "../../../modules/admin-modules/homework/Actions";
import { RiDeleteBinLine } from "react-icons/ri";
import HomeworkComment from "../../../containers/admin/reports/homework-comment";
import HomeworkRefuseComment from "../../../containers/admin/reports/refuse-homework";
import { openAdminHomeworkCommentModel, openRefuseHomeworkModel } from "../../../modules/admin-modules/models/Actions";
const HomeworkUncommentReport = () => {
  const dispatch = useDispatch();
  const [homeworkId, setHomeworkId] = useState("");

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [data, setData] = useState(null);
  useEffect(() => {
    if (homeworkId) dispatch(homeworkUncommentReportRequest(homeworkId));
  }, [homeworkId]);

  useEffect(() => {
    dispatch(getAllHomeworksRequest());
  }, []);

  const homeworks = useSelector((state) => state.homework.homeworks);
  const homeworkUncomment = useSelector(
    (state) => state.reports.homeworkUncomment
  );
  const isLoading = useSelector((state) => state.reports.isLoading);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#FFFFFF",
      borderColor: "rgba(214, 206, 192, 0.85)",
      borderRadius: "14px",
      minHeight: "44px",
      boxShadow: "none",
    }),
    menu: (styles) => ({
      ...styles,
      borderRadius: "14px",
      overflow: "hidden",
      border: "1px solid rgba(214, 206, 192, 0.85)",
      boxShadow: "0 14px 40px rgba(0,0,0,0.12)",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgba(139, 24, 40, 0.10)" : isFocused ? "rgba(122, 20, 34, 0.06)" : "#FFFFFF",
      color: "#7A1422",
      fontWeight: isSelected ? 800 : 600,
    }),
    singleValue: (styles) => ({ ...styles, color: "#7A1422", fontWeight: 800 }),
    placeholder: (styles) => ({ ...styles, color: "rgba(122, 20, 34, 0.55)", fontWeight: 700 }),
  };
  const homeworksOptions = homeworks?.map((data) => {
    return {
      value: data.id,
      label: `${data.name} (${data.unevaluated_count || 0})`,
    };
  });

  const viewData = (data) => {
    setData(data);
  };
  const headers = [{ label: "name", key: "name" }];
  const Data = homeworkUncomment?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      name: data?.student?.name,
      user_name: data?.student?.user_name,
      group: data?.student_group,
      created_at: data?.created_at
        ? (() => {
            const date = new Date(data.created_at);
            return date
              .toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
              }).replace(',', '');
          })()
        : "N/A",
      preview_answer: (
        <Button
          onClick={() => dispatch(openAdminHomeworkCommentModel())}
          size="sm"
          borderRadius="12px"
          bg="#8B1828"
          color="white"
          _hover={{ bg: "#7A1422" }}
        >
          Review submission
        </Button>
      ),
      delete: (
        <IconButton
          aria-label="Reject submission"
          size="sm"
          borderRadius="12px"
          variant="ghost"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() =>
            dispatch(
              openRefuseHomeworkModel()
            )
          }
        />
      ),
    };
  });
  const columns = [
    {
      Header: "#",
      accessor: "index",
    },
    {
      Header: "Student name",
      accessor: "name",
    },
    {
      Header: "Code",
      accessor: "user_name",
    },
    {
      Header: "Group",
      accessor: "group",
    },
    {
      Header: "Submitted at",
      accessor: "created_at",
    },
    {
      Header: " ",
      accessor: "preview_answer",
    },

    {
      Header: "  ",
      accessor: "delete",
    },
  ];

  const totalPage = Math.max(1, Math.ceil((Array.isArray(Data) ? Data.length : 0) / (size || 10)));

  return (
    <Layout>
      <Box minH="400px" pt={6} pb={10}>
        <Flex
          w="100%"
          mb={5}
          justifyContent="space-between"
          alignItems={{ base: "stretch", md: "center" }}
          gap={3}
          flexWrap="wrap"
        >
          <Box>
            <Text fontSize={{ base: "18px", md: "24px" }} fontWeight="900" color="#7A1422">
              Homework submissions (Pending review)
            </Text>
            <Text mt={1} fontSize="sm" fontWeight="700" color="rgba(122, 20, 34, 0.55)">
              Pick a homework to see students who submitted without evaluation/comment.
            </Text>
          </Box>

          <Flex align="center" gap={2} flexWrap="wrap" justifyContent={{ base: "flex-start", md: "flex-end" }}>
            <Box minW={{ base: "100%", md: "340px" }}>
              <Select
                options={homeworksOptions}
                isMulti={false}
                onChange={(d) => setHomeworkId(d?.value)}
                styles={colourStyles}
                placeholder="Select homework"
              />
            </Box>

            <Box
              border="1px solid rgba(214, 206, 192, 0.85)"
              bg="#FAF2EB"
              borderRadius="14px"
              p="6px"
            >
              <CSVLink
                headers={headers}
                data={Array.isArray(Data) && Data.length !== 0 ? Data : []}
                filename={"homework-uncomment-report.csv"}
                target="_blank"
                style={{ textDecoration: "none" }}
              >
                <Button
                  size="sm"
                  borderRadius="12px"
                  bg="white"
                  border="1px solid rgba(214, 206, 192, 0.85)"
                  _hover={{ bg: "rgba(255,255,255,0.75)" }}
                  fontWeight="800"
                  color="#7A1422"
                >
                  Download CSV
                </Button>
              </CSVLink>
            </Box>

            <LogoutMenu />
          </Flex>
        </Flex>

        <Box
          border="1px solid rgba(214, 206, 192, 0.85)"
          bg="#FAF2EB"
          borderRadius="18px"
          p={{ base: 3, md: 4 }}
          boxShadow="0 18px 55px rgba(0,0,0,0.08)"
        >
          <CTable
            selectedData={viewData}
            Columns={columns}
            Data={Data}
            path={"openModel"}
            Actions
            Title={``}
            subTitle=""
            btnTitle=""
            placeHolder=""
            noSearchBar={true}
            noFilter={true}
            footerBtnTitle
            filterList
            addButton
            addButtonTitle=""
            setPage={setPage}
            setPerPage={setPerPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            noSecondSearchBar={true}
            isLoading={isLoading}
            perPage={size}
            totalPage={totalPage}
          />
        </Box>
      </Box>
      <HomeworkComment data={data} homeworkId={homeworkId} />
      <HomeworkRefuseComment data={data} homeworkId={homeworkId} />
    </Layout>
  );
};

export default HomeworkUncommentReport;
